import './leaflet-map.tag'
import './infobox.tag'
import './searchbox.tag'

riot.tag2('ddjnrw-mst-map', '<searchbox></searchbox> <infobox></infobox> <leaflet-map config="{opts.CONFIG}"></leaflet-map>', '', 'class="ddjnrw-mst-map__container"', function(opts) {
});



// WEBPACK FOOTER //
// ./src/components/ddjnrw-mst-map.tag